<template>
    <div>
        <vue-bootstrap-typeahead 
          v-model='selectedClientName'
            :minMatchingChars="1"
            :data="clientList"
            :serializer="this.clientLabel"
            @hit="emitHit($event)"
            v-if="!isLoadingList"
            />

        <b-spinner v-if="isLoadingList"/>
        <a @click="selectedClientName='';emitClear()" size="sm" variant="danger" class="delete-btn">xoá</a>
    </div>

</template>

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap'

import ClientService from '@/module-client/ClientService'

import Constants from '@/constants'
import moment from 'moment'
import axios from 'axios'

// import ProductService from '@/services/productService'

export default {
  name: 'GenericDetailView',
  components: {
    'vue-bootstrap-typeahead': VueBootstrapTypeahead,
  },
  props: {

    },
  computed: {

  },
  data () {
    return {
        clientList: [{
            id: 1,
            fullname: 'text 1'
        }],
        selectedClientName: '',
        isLoadingList: false,
    }
  },
  watch: {

  },
  methods: {
      emitHit(client) {
          console.log('hit from widget: ', client); 
          this.$emit('hit',client)
      },

      emitClear() {
        this.$emit('hit',null)
      },

      clientLabel(s) {
          return s.fullname
      },

      async loadClientList () {
        var service = new ClientService();
        var results = await service.listSimple2();
        this.clientList = results;

        console.log('Client ', results);
    },
  },
  mounted () {
    this.loadClientList();
  }
}
</script>


<style scoped> 
.delete-btn {
    font-weight: bold;
    text-decoration: underline;
    font-style: italic;
    cursor: pointer;
    color: red;
}
</style>
